import React from 'react';

const Tips = () => {
  return (
    <div
      style={{
        backgroundColor: '#fff3cd',
        color: '#856404',
        padding: '12px 20px',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        borderBottom: '1px solid #ffeeba',
        zIndex: 9999,
        position: 'sticky',
        top: 0,
      }}
    >
      公司官网已启用新域名
      zjsjjc.cn，请大家更新收藏及相关链接，以便后续正常访问。
      {/* 直接跳转到新域名的按钮 */}
      <a
        href={`http://zjsjjc.cn${window.location.pathname}`}
        style={{
          marginLeft: '15px',
          color: '#0056b3',
          textDecoration: 'underline',
          fontWeight: 'normal',
        }}
      >
        点击前往新域名访问 {'>>'}
      </a>
    </div>
  );
};

export default Tips;
